/**
 * Centrale rolle-tjek for Norewyn Academy.
 *
 * Brug disse helpers i stedet for at gentage `me.role === 'admin' || ...`
 * - de sikrer at superadmin altid er inkluderet hvor relevant.
 *
 * Bemærk: superadmin normaliseres til admin ved login i AppContext,
 * men vi tjekker for sikkerheds skyld eksplicit i case af direkte
 * Firestore-læsninger eller fremtidige edge cases.
 */

export type Role = 'student' | 'parent' | 'guardian' | 'admin' | 'superadmin';

/** Staff = kan moderere, oprette indhold, se vogter-UI (admin + superadmin + guardian) */
export const isStaff = (role?: string): boolean =>
  role === 'admin' || role === 'superadmin' || role === 'guardian';

/** Admin-niveau = kan ændre system, brugere, persona-arkiv (admin + superadmin) */
export const isAdmin = (role?: string): boolean =>
  role === 'admin' || role === 'superadmin';

/** Student = elev */
export const isStudent = (role?: string): boolean =>
  role === 'student';

/**
 * Pædagogisk staff = vogtere som elever og forældre interagerer med (admin + guardian).
 *
 * Bemærk: superadmin er bevidst IKKE inkluderet — det er en teknisk system-rolle
 * (platform-ejer), ikke en pædagogisk vogter. Brug `isStaff` hvis du vil dække
 * alle tre roller (fx for autorisation til at moderere indhold).
 */
export const isPedagogicalStaff = (role?: string): boolean =>
  role === 'admin' || role === 'guardian';
